import React from "react";
import {
  Breadcrumb,
  Dropdown,
} from "react-bootstrap";

import {
  FiHome,
  FiFileText,
  FiChevronDown,
  FiChevronsUp,
} from "react-icons/fi";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import {  Col } from 'react-bootstrap';

export default function PayrollItemsHeader() {
  return (
    <div
      style={{
        background: "#f4f6f9",
        padding:
          window.innerWidth <= 768
            ? "14px"
            : "0px",
      }}
    >
      <div
        className="page-breadcrumb"
        style={{
          display: "flex",
          justifyContent:
            "space-between",
          alignItems:
            window.innerWidth <= 768
              ? "flex-start"
              : "center",
          flexDirection:
            window.innerWidth <= 768
              ? "column"
              : "row",
          gap: "14px",
          marginBottom: "16px",
        }}
      >
        {/* LEFT */}
  <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Payroll Items</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                      Payroll
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">PayrollItems</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>

        {/* RIGHT */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            width:
              window.innerWidth <= 768
                ? "100%"
                : "auto",
          }}
        >
          {/* EXPORT */}
          <Dropdown>
            <Dropdown.Toggle
              style={{
                height: "50px",
                borderRadius: "8px",
                border:
                  "1px solid #e5e7eb",
                background: "#fff",
                color: "#111827",
                fontSize: "16px",
                fontWeight: "500",
                padding: "0 18px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                width:
                  window.innerWidth <= 768
                    ? "100%"
                    : "auto",
                justifyContent:
                  window.innerWidth <= 768
                    ? "space-between"
                    : "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <FiFileText size={17} />
                Export
              </div>

              <FiChevronDown size={16} />
            </Dropdown.Toggle>

            <Dropdown.Menu
              align="end"
              style={{
                borderRadius: "10px",
                border:
                  "1px solid #e5e7eb",
                padding: "10px",
                minWidth: "200px",
              }}
            >
              <Dropdown.Item
                style={{
                  borderRadius: "6px",
                  padding: "10px 12px",
                  fontSize: "15px",
                  marginBottom: "4px",
                }}
              >
                Export as PDF
              </Dropdown.Item>

              <Dropdown.Item
                style={{
                  borderRadius: "6px",
                  padding: "10px 12px",
                  fontSize: "15px",
                }}
              >
                Export as Excel
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {/* COLLAPSE */}
          <button
            style={{
              width: "48px",
              height: "48px",
              borderRadius: "8px",
              border:
                "1px solid #e5e7eb",
              background: "#fff",
              color: "#111827",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              flexShrink: 0,
            }}
          >
            <FiChevronsUp size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}